import { PropsWithChildren } from 'react'

export const MobilityBonusLayout = ({ children }: PropsWithChildren) => (
  <div className="tw-flex tw-justify-center tw-bg-[#F2F4F6]">
    <div id="modal-root" />
    <main className="tw-min-h-screen tw-w-screen tw-min-w-[320px] tw-max-w-[420px] tw-bg-white">
      {children}
    </main>
  </div>
)
